/*
 * @Description: 名单库添加
 * @LastEditors: jml
 * @Date: 2020-11-10 13:57:25
 */
import { projectPersonnelManagement } from '@/api/ajax';
import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';

let example = new TableRenderClass({ fields, search });

let part = example.createPart({
  name: '任务撤回',
  list: projectPersonnelManagement.getUserTaskRevokeList,

  requestNow: true,
  search: ['fullName', 'phone', 'monthrange'],
  fields: ['index', 'fullName', 'phone', 'taskDt', 'revokeCount', 'revokeDt']
});

let individualPart = example.createPart({
  name: '任务撤回',
  list: projectPersonnelManagement.getUserTaskRevokeList,

  requestNow: true,
  search: [
    {
      width: 180,
      label: '经营者',
      tip: '请输入关键字',
      key: 'fullName',
      id: 'fullName',
      slot: 'input'
    },
    'phone',
    'monthrange'
  ],
  fields: [
    'index',
    {
      label: '经营者',
      prop: 'fullName'
    },
    'enterpriseName',
    'phone',
    'taskDt',
    'revokeCount',
    'revokeDt'
  ]
});

export default [
  [{ name: '任务撤回', childMenu: [part] }],
  [{ name: '任务撤回', childMenu: [individualPart] }]
];
